/**
 * AMP PDF Processor - Main Entry Point
 *
 * Initializes the PDF processor application.
 */

import { PDFProcessor } from './app';

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Initialize the processor
  const processor = new PDFProcessor('main-panel');

  // Set up Clear Cache button (in header, outside panel)
  const clearCacheBtn = document.getElementById('clear-cache');
  if (clearCacheBtn) {
    clearCacheBtn.addEventListener('click', () => {
      processor.clearCache();
      // Visual feedback
      clearCacheBtn.textContent = 'Cleared!';
      setTimeout(() => {
        clearCacheBtn.textContent = 'Clear Cache';
      }, 1500);
    });
  }

  // Expose to window for debugging
  (window as unknown as { processor: PDFProcessor }).processor = processor;

  console.log('AMP PDF Processor initialized');
  console.log('All processing happens client-side - no server required');
});

